export default __webpack_public_path__ + "static/media/004-cloud computing.33bd9d82.svg";